import React, { ReactNode } from "react"
import { MenuItem as ChakraMenuItem, Text } from "@chakra-ui/react"
import Icon from "components/elements/Icon"

// Compact dropdown styling for the merge-field pickers in the WhatsApp template
// editor and the SMS Lexical editor. Section titles are left-aligned plain gray
// text (no background, no borders); items sit at a slightly deeper indent with
// a smaller font and tighter row height than the canonical Menu.
//
// Scoped to the merge-field menus on purpose — do not generalize without a
// concrete second use case.

type MergeFieldMenuGroupProps = {
  title: string
  children: ReactNode
}

export const MergeFieldMenuGroup = ({ title, children }: MergeFieldMenuGroupProps) => (
  <>
    <Text px={3} pt={3} pb={1} fontSize="sm" color="gray.500" fontWeight="medium">{title}</Text>
    {children}
  </>
)

type MergeFieldMenuItemProps = {
  children: ReactNode
  onClick?: () => void
  selected?: boolean
  isDisabled?: boolean
  color?: string
}

export const MergeFieldMenuItem = ({
  children, onClick, selected, isDisabled, color,
}: MergeFieldMenuItemProps) => (
  <ChakraMenuItem
    onClick={onClick}
    isDisabled={isDisabled}
    color={color}
    fontSize="sm"
    pl={6}
    pr={3}
    py={1.5}
  >
    {selected !== undefined && (
      <Icon
        icon="checkmark"
        color="gray.600"
        ml={-4}
        mr={2}
        visibility={selected ? "visible" : "hidden"}
      />
    )}
    {children}
  </ChakraMenuItem>
)
